import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  header: {
    color: theme.palette.secondary.tint40,
  },
  iconContainer: {
    display: "flex",
  },
  iconBtn: {
    padding: theme.spacing(6, 0),
    display: "flex",
    alignItems: "center",
    "& i": {
      color: theme.palette.secondary.tint100,
      fontSize: theme.spacing(12),
      marginRight: theme.spacing(3),
    },
    "& button": {
      paddingLeft: 0,
    },
  },
  content: {
    height: theme.spacing(100),
    boxShadow: "0px 14px 10px -18px rgba(0,0,0,0.66)",
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      width: 0,
    },
  },
  bottomButtons: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  },
  Btn: {
    "& .MuiButton-label": {
      "&:hover": {
        color: theme.palette.secondary.main,
      },
    },
  },
}));
